import EditGame from './EditGame'
export default EditGame